import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck, Zap, TrendingUp } from 'lucide-react';
import { Button } from './ui/button';
import { SIGNUP_URL } from '../data/mock';
import VideoModal from './VideoModal';

export default function CTA() {
  const [videoOpen, setVideoOpen] = useState(false);
  return (
    <section className="section">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-slate-950 p-10 md:p-16 text-center">
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-brand-purple/25 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-brand-green/15 blur-3xl" />

          <p className="chip !bg-brand-purple/10 !text-purple-200 !border-brand-purple/30">
            Start Growing Today
          </p>
          <h2 className="mt-5 text-3xl md:text-5xl font-extrabold text-white leading-tight max-w-3xl mx-auto">
            Ready to Automate Conversations. Ready to Grow.
          </h2>
          <p className="mt-4 text-slate-300 max-w-2xl mx-auto">
            Join businesses that trust ACTIWA to save time, engage better and grow faster.
            Let ACTIWA handle the conversations, so you can focus on what matters most — growing your business.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <a href={SIGNUP_URL} target="_blank" rel="noreferrer">
              <Button size="lg" className="bg-brand-purple hover:bg-brand-purple-dark text-white rounded-full px-7 h-12">
                Start Free Trial <ArrowRight size={18} className="ml-2" />
              </Button>
            </a>
            <Button
              size="lg"
              variant="outline"
              onClick={() => setVideoOpen(true)}
              className="rounded-full px-7 h-12 bg-transparent text-white border-slate-600 hover:bg-white/5 hover:text-white"
            >
              Watch Demo
            </Button>
          </div>

          <div className="mt-10 grid sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
            {[
              { Icon: ShieldCheck, t: 'Meta Business Partner' },
              { Icon: Zap, t: '24/7 Automated Support' },
              { Icon: TrendingUp, t: 'More Leads. More Sales.' },
            ].map(({ Icon, t }) => (
              <div key={t} className="bg-white/5 border border-white/10 rounded-2xl p-4 text-white flex items-center gap-3 justify-center">
                <Icon size={18} className="text-brand-green" />
                <span className="text-sm font-semibold">{t}</span>
              </div>
            ))}
          </div>
          <p className="mt-6 text-xs text-slate-400">No credit card required • 7-day free trial • Cancel anytime</p>
        </div>
      </div>
      <VideoModal open={videoOpen} onClose={() => setVideoOpen(false)} />
    </section>
  );
}
